export const ADD_PRODUCT_BASKET = "ADD_PRODUCT_BASKET";
export const GET_NUMBERS_BASKET = "GET_NUMBERS_BASKET";
export const DELETE_PRODUCT_BASKET = "DELETE_PRODUCT_BASKET";
export const ADD_GA_PRODUCT = "ADD_GA_PRODUCT";
export const DELETE_GA_PRODUCT = "DELETE_GA_PRODUCT";
export const GET_GA_PRODUCT = "GET_GA_PRODUCT";
export const GET_VIP_PRODUCT = "GET_VIP_PRODUCT";
export const DELETE_VIP_PRODUCT = "DELETE_VIP_PRODUCT";
export const ADD_VIP_PRODUCT = "ADD_VIP_PRODUCT";
export const EMPTY_BASKET = "EMPTY_BASKET";
export const EMPTY_VIP_BASKET = "EMPTY_VIP_BASKET";
export const EMPTY_GA_BASKET = "EMPTY_GA_BASKET";
